
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 21"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.55 3.5H16.1V2.333a2.35 2.35 0 00-.674-1.65A2.283 2.283 0 0013.8 0H9.2c-.61 0-1.195.246-1.626.683a2.35 2.35 0 00-.674 1.65V3.5H3.45c-.915 0-1.793.369-2.44 1.025A3.526 3.526 0 000 7v10.5c0 .928.363 1.819 1.01 2.475A3.425 3.425 0 003.45 21h16.1c.915 0 1.793-.369 2.44-1.025A3.526 3.526 0 0023 17.5V7c0-.928-.363-1.819-1.01-2.475A3.425 3.425 0 0019.55 3.5zM9.2 2.333h4.6V3.5H9.2V2.333zM20.7 17.5c0 .31-.121.606-.337.825a1.142 1.142 0 01-.813.342H3.45c-.305 0-.598-.123-.813-.342A1.175 1.175 0 012.3 17.5v-6.545l5.382 1.878c.122.017.246.017.368 0h6.9c.125-.002.248-.022.368-.058l5.382-1.82V17.5zm0-9.007L14.766 10.5H8.234L2.3 8.493V7c0-.31.121-.606.337-.825.215-.219.508-.342.813-.342h16.1c.305 0 .598.123.813.342.216.219.337.516.337.825v1.493z"}})])
          )
        }
      }
    